/**
 * Spec 081b — app copy for the package phone preview (EN/AR), kept apart from the portal strings
 * because it mirrors what the customer app shows (Moby canvas: navy card, "from AED X", "-N%").
 */
export const PHONE_COPY = {
  en: {
    phoneLabel: 'Package preview on a phone',
    row: 'Packages & offers',
    tag: 'Package',
    services: (n: number) => (n === 1 ? '1 service' : `${n} services`),
    from: 'from',
    ends: (d: string) => `Ends ${d}`,
    save: (amount: string) => `Save ${amount}`,
    off: (n: number) => `-${n}%`,
    included: 'Included services',
    options: 'Choose your options',
    required: 'Required',
    choose: 'Choose',
    pickHint: 'Pick your options to see the final price.',
    total: 'Package price',
    book: 'Book package',
    promo: 'You can still add a promo code at checkout',
  },
  ar: {
    phoneLabel: 'معاينة الباقة على الهاتف',
    row: 'الباقات والعروض',
    tag: 'باقة',
    services: (n: number) => (n === 1 ? 'خدمة واحدة' : n === 2 ? 'خدمتان' : n <= 10 ? `${n} خدمات` : `${n} خدمة`),
    from: 'ابتداءً من',
    ends: (d: string) => `ينتهي ${d}`,
    save: (amount: string) => `وفّر ${amount}`,
    off: (n: number) => `-${n}٪`,
    included: 'الخدمات المشمولة',
    options: 'اختر خياراتك',
    required: 'مطلوب',
    choose: 'اختر',
    pickHint: 'اختر خياراتك لرؤية السعر النهائي.',
    total: 'سعر الباقة',
    book: 'احجز الباقة',
    promo: 'لا يزال بإمكانك إضافة كود خصم عند الدفع',
  },
};

export type PhoneCopy = typeof PHONE_COPY.en;

export const phoneAed = (n: number | null | undefined) =>
  (n == null ? '—' : `AED ${n.toLocaleString('en-US', { maximumFractionDigits: 2 })}`);

export function phoneShortDate(iso: string, lang: 'en' | 'ar'): string {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  return new Date(Date.UTC(y, (m || 1) - 1, d || 1))
    .toLocaleDateString(lang === 'ar' ? 'ar-AE' : 'en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });
}
